import { formatDate } from '../../../../../../lib/date';

const DayList = ({ days, challenge, routines, log, handleSelectDay }) => {
  const isRestDay = (index) => {
    return (
      routines.find((routine) => routine.dayNumber === index + 1) === undefined
    );
  };

  const isDone = (day) => {
    return log.some((item) => (item.logDate === formatDate(day)) === true);
  };

  const isCompleted = () => {
    const distinctLogDays = new Set(log.map((item) => item.logDate));
    return distinctLogDays.size === days.length;
  };

  return (
    <div className='grid grid-cols-4 gap-4 mb-8'>
      {days.map((day, index) => (
        <button
          key={index}
          className='relative flex justify-center items-center'
          onClick={
            challenge.status === 'ONGOING' || challenge.status === 'INCOMPLETE'
              ? handleSelectDay(day, index)
              : null
          }
        >
          <div
            className={`flex justify-center items-center rounded-full size-12 font-bold ${
              isDone(day) ? 'bg-gray-700 text-white' : 'text-gray-400'
            } ${new Date() < day ? 'bg-gray-100' : 'border'}`}
          >
            {index + 1}
          </div>
          {challenge.category !== 'HABIT' && isRestDay(index) && (
            <div
              className={`absolute bottom-[2px] uppercase text-[9px] font-semibold ${
                isDone(day) ? 'text-white' : 'opacity-40'
              }`}
            >
              rest
            </div>
          )}
        </button>
      ))}
      <div className='flex justify-center items-center'>
        <div
          className={`text-4xl ${
            isCompleted() ? 'brightness-125' : 'grayscale'
          }`}
        >
          🏆
        </div>
      </div>
    </div>
  );
};

export default DayList;
